"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderGridPanels = void 0;
var color_library_wrappers_1 = require("../../../../../common/color_library_wrappers");
var canvas_1 = require("../../../../../renderers/canvas");
var rect_1 = require("../primitives/rect");
function renderGridPanels(ctx, chartAnchor, panels) {
    canvas_1.withContext(ctx, function (ctx) {
        ctx.translate(chartAnchor.x, chartAnchor.y);
        panels.forEach(function (panel) {
            canvas_1.withContext(ctx, function (ctx) {
                ctx.translate(panel.panelAnchor.x, panel.panelAnchor.y);
                canvas_1.withContext(ctx, function (ctx) {
                    rect_1.renderRect(ctx, __assign({ x: 0, y: 0 }, panel), { color: color_library_wrappers_1.stringToRGB('#00000000') }, { color: color_library_wrappers_1.stringToRGB('#000000'), width: 1 });
                });
            });
        });
    });
}
exports.renderGridPanels = renderGridPanels;
//# sourceMappingURL=panels.js.map